import { Container, Progress } from './ProgressBar.styles';

interface ProgressBarProps {
  value: number;
}

export const ProgressBar = ({ value }: ProgressBarProps): JSX.Element => {
  return (
    <Container>
      <Progress
        role="progressbar"
        aria-valuenow={value}
        aria-valuemin={0}
        aria-valuemax={100}
        value={value}
      />
    </Container>
  );
};
